export const CACHE_FIRST_HEADER = 'x-pace-prefer-cache';

/**
 * Checks whether the current runtime environment supports the Cache API.
 *
 * @returns true if the Cache API is supported
 */
export function cacheSupported(): boolean {
    return typeof window !== 'undefined' && 'caches' in window;
}
